import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  ListItemText,
  MenuItem,
  Popper,
  TextField,
  Typography,
} from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import ToolTipComponent from '../Components/ToolTipComponent';
import SettingsIcon from '@mui/icons-material/Settings';
import { Settings } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import TreeDropdown from '../../../components/DropDown/CategoryDropDown';
import debounce from 'lodash.debounce';
import { AddBox } from '@mui/icons-material';
import { listGeneralSetting, listVoucherSerialNumbers, searchHSN } from '../../../graphql';
import { API, graphqlOperation } from 'aws-amplify';
import { useLocation } from 'react-router-dom';
import { showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import AddUnitsModal from '../../../components/modals/AddUnits';
import AddHSNModal from '../Modals/AddHSNModal';
import AddItemsAccountModal from '../Modals/AddItemsAccountModal';
import { handleFreeze } from '../../../utils/common';
import { useDispatch, useSelector } from 'react-redux';
import { useThemes } from '../../../components/Theme/theme';
import { getCompanyCodeTranslationApi, useGetCompanyCodeTranslationQuery } from '../../../redux/apis/getCompanyCodeTranslation.api';
import { useGetCodeTranslationQuery } from '../../../redux/apis/getCodeTranslation.api';
import { useListAccountMasterv2Query } from '../../../redux/apis/accountMaster.api';
import { useListVoucherSerialNumbersQuery } from '../../../redux/apis/newVoucherSettings.api';
import NewVoucherSettingsModal from '../Modals/newVoucherSettingModal';
import UseHSNMaster from '../Components/UseHSNMaster';
import { CheckVoucherValid } from '../Components/CheckVoucherValid';

function ItemBasicDetails({
  Type,
  data,
  setData,
  mainCategoryId,
  setMainCategoryId,
  setInitialState,
  setCategoryId,
  view,
  registrationType,
  categoryId,
  setRegistrationType,
  companyData,
  setBackdropOpen,
  itemData,
  setTaxableValue,
  modalEvent,
  autoFocus,
  itemID,
  setAccNames,
  newSalesObj,
  newPurchaseObj,
  updatedPurchasePrice,
  updatedSalesPrice,
  setSellingPriceRows,
  setPurchasePriceRows,
  sellingPriceRows,
  purchasePriceRows,
  setSalesValid,
  setPurchaseValid,
  sellingPriceObj,
  purchasePriceObj,
}) { 
  const { theme } = useThemes();
  let dispatch = useDispatch();
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  const companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
  const Taxability =
    companyType === 3
      ? [
          { label: 'Composition - Taxable', value: 1 },
          { label: 'Exempted', value: 2 },
          { label: 'Non-Taxable(Non-GST)', value: 3 },
          { label: 'Out of scope', value: 5 },
        ]
      : [
          { label: 'Taxable', value: 1 },
          { label: 'Exempted', value: 2 },
          { label: 'Non-Taxable(Non-GST)', value: 3 },
          { label: 'GST Reverse Charge', value: 4 },
          { label: 'Out of scope', value: 5 },
        ];
  let location = useLocation();
  let params = location.state;
  if (params == null) {
    params = { view: view };
  }

  const { filterHSN, setFilterHSN, searchHSNDetails, HSNListboxProps, setRow } = UseHSNMaster({ Type: Type, Page: '' });
  const { data: ledgerList } = useListAccountMasterv2Query();
  let EInvoiceFlag = getCompany?.relatedcompanydetailsnew?.[0]?.einvoiceflag;
  const [openUnitModal, setUnitModal] = useState(false);
  const [generalSettingsFlag, setGeneralSettingsFlag] = useState(-1);
  const [openSalesAccountModal, setOpenSalesAccountModal] = useState(false);
  const [openPurchaseAccountModal, setOpenPurchaseAccountModal] = useState(false);
  const [accountType, setAccountType] = useState('');
  const [activeVouchers, setActiveVouchers] = useState([]);
  const [openSettingsModal, setOpenSettingsModal] = useState(false);
  const [focusEf, setFocusEf] = useState('');
  const [serialNos, setSerialNos] = useState([]);
  const [uqcArray, setUQCArray] = useState([]);
  const [purchaseArr, setPurchaseArr] = useState([]);
  const [allAccountArr, setAllAccountArr] = useState([]);
  const [displayAllAccounts, setDisplayAllAccounts] = useState({
    sales: false,
    purchase: false,
  });
  const [salesArr, setSalesArr] = useState([]);
  const [newUnit, setNewUnit] = useState({ option: '', value: '' });
  const [openHsnModal, setOpenHsnModal] = useState(false);
  const [hsnParamsID, setHSNParamsID] = useState('');
  const [showItems, setShowItems] = useState([]);
  const [openMpdalFlag, setOpenModalFlag] = useState(false);
  const [checked, setChecked] = useState(true);
  const [newAccID, setNewAccID] = useState('');
  const checkSettings=modalEvent?itemID:params?.id
  const {
    data: voucherList,
    isLoading: isVoucherListLoading,
    isError: isVoucherListError,
    // refetch
  } = useListVoucherSerialNumbersQuery({
    entrytypecd: Type === 'GOODS' ? 'Item' : 'Service',
  });
  async function getGeneralSettings() {
    try {
      setBackdropOpen(true);
      const res = await API.graphql(
        graphqlOperation(listGeneralSetting, {
          entrytypecd: Type === 'GOODS' ? 'Item' : 'Service',
          financialyearid: getCompany.financialyearid,
        })
      );

      let nextInvNo = '';
      let prefix = '';
      let suffix = '';
      let serialNoArr = [];
      let itemCode = '';
      let itemCodeSereis={label:'',value:''}

      if (res?.data?.listGeneralSetting?.length > 0) {
        let settingsArr = res.data?.listGeneralSetting?.map((ele) => {
          if (ele.expiredtimestamp == 0) {
            prefix = ele.prefix;
            suffix = ele.suffix;
            nextInvNo = ele.nextinvoicenumber;
            return ele;
          }
        });

        if (nextInvNo !== -1) {
          let activeVouchers = res.data?.listGeneralSetting?.filter((voucher) => voucher.serialisactive == 1);

          setActiveVouchers(activeVouchers);
  

          activeVouchers?.map((ele) => {
            serialNoArr?.push({
              label: ele.prefix + ele.nextinvoicenumber + ele.suffix,
              value: ele.serialnumber,
            });
            // if (ele.serialnumber === serialNoArr?.[0]?.value) {
              if(ele?.lastused===1){
              itemCode = ele.prefix + ele.nextinvoicenumber + ele.suffix;
              itemCodeSereis={label:ele.prefix + ele.nextinvoicenumber + ele.suffix,value:ele?.serialnumber};
            }else{
             if (ele.serialnumber === serialNoArr?.[0]?.value) {
               itemCode = ele.prefix + ele.nextinvoicenumber + ele.suffix;
              itemCodeSereis={label:ele.prefix + ele.nextinvoicenumber + ele.suffix,value:ele?.serialnumber};
             }
            }
          });
          setSerialNos(serialNoArr);
          if (itemData.length === 0) {
            setGeneralSettingsFlag(nextInvNo);
            setData((prev) => ({
              ...prev,
              itemCode: itemCode,
              voucherSeries:itemCodeSereis
              //  {
              //   label: serialNoArr?.[0]?.label,
              //   value: serialNoArr?.[0]?.value,
              // },
            }));
            setInitialState((prev) => ({
              ...prev,
              itemCode: itemCode,
              voucherSeries:itemCodeSereis
              // voucherSeries: {
              //   label: serialNoArr?.[0]?.label,
              //   value: serialNoArr?.[0]?.value,
              // },
            }));
          }
        } else {
          if (itemData.length === 0) {
            setData((prev) => ({
              ...prev,
              itemCode: '',
              voucherSeries: { label: '', value: '' },
            }));
            setInitialState((prev) => ({
              ...prev,
              itemCode: '',
              voucherSeries: { label: '', value: '' },
            }));
            setGeneralSettingsFlag(-1);
          }
        }
      }
      setBackdropOpen(false);
    } catch (error) {
      console.log('error', error);
      setBackdropOpen(false);
    }
  }
  function categoryChange(currentNode) {
    console.log(currentNode);
    setData((prev) => ({
      ...prev,
      itemCtegorey: currentNode?.value == undefined ? '' : currentNode?.value[1],
      errorStatus: {
        ...prev.errorStatus,
        itemCtegorey: false,
      },
      errorFields: {
        ...prev.errorFields,
        itemCtegorey: '',
      },
    }));
    setCategoryId({ id: currentNode.value[1] });
  }
  const {
    data: unitList,
    isLoading: isUnitListLoading,
    isError: isUnitListError,
  } = useGetCompanyCodeTranslationQuery({ codetype: 'UNITS' });
  const { data: unitUQC, isLoading: idUqcLoading, isError: isUqcError } = useGetCodeTranslationQuery({ codetype: 'UNITS' });
  async function getUnit() {
    try {
      dispatch(getCompanyCodeTranslationApi.util.invalidateTags([{ type: 'CodeTranslation', id: 'UNITS' }]));
    } catch (err) {
    } finally {
    }
  }
  let unitsArrayList = useMemo(() => {
    if (!unitList) return [];
    let unitsArray = [];
    unitList?.map((element) => {
      if (element.is_active === '1') {
        unitsArray.push({ option: element.codetext, value: `${element.id}` });
      }
    });
    unitsArray?.map((item) => {
      if (item.option === newUnit.option) {
        setData((prev) => ({
          ...prev,
          unite: item.value,
        }));
      }
    });
    // setUnits(unitsArray);
    return unitsArray;
  }, [unitList]);

  let uqcArrayList = useMemo(() => {
    if (!unitUQC) return [];
    return unitUQC
      .filter((item) => item.uqc !== null)
      .map((element) => {
        return { option: element.uqc, value: `${element.id}` };
      });
  }, [unitUQC]);
  let [hsnInitial, setHsnInitial] = useState([]);
  // async function searchHSNDetails(value, type) {
  //   try {
  //     let arrofHsnSac = [];
  //     const res = await API.graphql(
  //       graphqlOperation(searchHSN, {
  //         rowfrom: 0,
  //         limitno: hsnInitial.length == 0 ? 10 : 10000,
  //         word: value,
  //       })
  //     );

  //     if (res.data.searchHSN !== null) {
  //       if (type === "GOODS") {
  //         res.data.searchHSN.map((ele) => {
  //           if (ele.codetype == "HSN") {
  //             arrofHsnSac.push(ele);
  //           }
  //         });
  //       } else {
  //         res.data.searchHSN.map((ele) => {
  //           if (ele.codetype == "SAC") {
  //             arrofHsnSac.push(ele);
  //           }
  //         });
  //       }
  //     }
  //     let hsnObj = {
  //       label: "",
  //       value: "",
  //       companyID: "",
  //       hsnID: "",
  //       codetype: "",
  //     };
  //     let arr = [];
  //     if (arrofHsnSac.length > 0) {
  //       await Promise.all(
  //         arrofHsnSac.map((item) => {
  //           arr.push({
  //             label: `${item.hsnsaccode} - ${item.description}`,
  //             value: `${item.hsnsaccode}`,
  //             companyID: item.companyid,
  //             hsnID: item.hsnsacid,
  //             codetype: item.codetype,
  //             description: item.description,
  //           });
  //           if (Number(item.hsnsaccode) === Number(value)) {
  //             hsnObj = {
  //               label: `${item.hsnsaccode} - ${item.description}`,
  //               value: `${item.hsnsaccode}`,
  //               companyID: item.companyid,
  //               hsnID: item.hsnsacid,
  //               codetype: item.codetype,
  //               description: item.description,
  //             };
  //           }
  //         })
  //       );
  //     }
  //     if (hsnObj.label === "" && value !== 0) {
  //       hsnObj = {
  //         label: value,
  //         value: value,
  //       };
  //     }
  //     if (hsnInitial.length == 0) {
  //       setHsnInitial(arr);
  //     }
  //     setFilterHSN(arr.length <= 10 ? [...arr, ...hsnInitial] : arr);
  //     return { hsnObj, arr };
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  // const handleSearch = useCallback(
  //   debounce((searchValue, Type) => {
  //     searchHSNDetails(searchValue, Type);
  //   }, 500),
  //   []
  // );
  function comparePathWithId(pathString, ...ids) {
    const pathArray = pathString?.replace(/^\/|\/$/g, '').split('/');
    const pathWithoutAccountId = pathArray?.slice(0, -1);

    return ids.some((id) => pathWithoutAccountId?.includes(id.toString()));
  }
  async function listAccountMasters() {
    try {
      let salesArr = [];
      let purchaseArr = [];
      let all = [];
      const res = { data: { listAccountMasterv2: ledgerList } };
      if (res.data.listAccountMasterv2 !== null) {
        const filteredLedgerList = res.data.listAccountMasterv2.filter(
          (item) =>
            item?.accountsid !== 12 &&
            (companyType !== 1 || (item.accountsid !== 32 && item.accountsid !== 33 && ![2, 4, 5].includes(item.tax_type)))
        );

        filteredLedgerList?.map((ele) => {
          let groupName = ele.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();
          all.push({
            label: ele.accountname,
            value: ele.accountsid,
            groupName,
          });
        });

        const filteredPurchaseArray = filteredLedgerList?.filter((item) => {
          return comparePathWithId(item.path, 21, 23);
        });
        filteredPurchaseArray.map((ele) => {
          let groupName = ele.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();
          if (ele.accountsid !== 41) {
            purchaseArr.push({
              label: ele.accountname,
              value: ele.accountsid,
              groupName,
            });
          }
        });
        const filteredSalesArray = filteredLedgerList?.filter((item) => {
          return comparePathWithId(item.path, 19, 22);
        });
        filteredSalesArray.map((ele) => {
          let groupName = ele.accountgroupname?.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim();

          salesArr.push({
            label: ele.accountname,
            value: ele.accountsid,
            groupName,
          });
        });
        let GSTArrayValues = [4, 5, 6, 7, 8, 9, 10, 11, 19, 20, 29];
        let setArrayAll =
          companyData?.relatedcompanydetailsnew?.[0].registrationtype !== 1
            ? [...all]
            : all.filter((e) => !GSTArrayValues.includes(e.value));
        setAllAccountArr(setArrayAll);
        setSalesArr(salesArr);
        setPurchaseArr(purchaseArr);
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  async function displayItemDetails(itemData) {
    let purchaseObj = { label: '', value: '' };
    let salesObj = { label: '', value: '' };
    let taxObj = { label: '', value: '' };
    let showItemsArr = [];
    if (itemData.purchaseinvoiceflag === 1) {
      showItems.map((ele) => {
        if (ele.value === 1) {
          showItemsArr.push(ele);
        }
      });
    }
    if (itemData.salesinvoiceflag === 1) {
      showItems.map((ele) => {
        if (ele.value === 2) {
          showItemsArr.push(ele);
        }
      });
    }
    setBackdropOpen(true);

    let hsnobj254 = {};
    let hsnCode = {
      label: '',
      value: 0,
      companyID: '',
      hsnID: 0,
      codeType: '',
      description: '',
    };
    if (itemData.hsncodevalue !== null) {
      hsnCode = {
        label: `${itemData.hsncodevalue} - ${itemData.hsndescription}`,
        value: itemData?.hsncodevalue,
        companyID: itemData?.companyid,
        hsnID: itemData?.hsnsacid,
        codeType: itemData?.hsncodetype,
        description: itemData.hsndescription,
      };
    }

    // hsnobj254 = await searchHSNDetails(
    //   itemData?.hsncodevalue === null ? "" : itemData.hsnid,
    //   itemData?.itemtype
    // );
    // hsnCode = hsnobj254?.hsnObj;
    if (itemData?.purchaseinvoiceflag === 1) {
      allAccountArr.map((ele) => {
        if (ele.value === itemData?.purchaseaccountid) {
          purchaseObj = { label: ele.label, value: ele.value };
        }
      });
    }
    if (itemData?.salesinvoiceflag === 1) {
      allAccountArr.map((ele) => {
        if (ele.value === itemData?.salesaccountid) {
          salesObj = { label: ele.label, value: ele.value };
        }
      });
    }
    if (itemData?.salesinvoiceflag === 1) {
      allAccountArr.map((ele) => {
        if (ele.value === itemData?.salesaccountid) {
          salesObj = { label: ele.label, value: ele.value };
        }
      });
    }

    Taxability.map((ele) => {
      if (ele.value == itemData?.taxabilitycd) {
        taxObj = { label: ele.label, value: ele.value };
      }
    });
    if (taxObj.value == 2 || taxObj.value == 3 || taxObj.value == 5) {
      setRegistrationType(1);
    }
    const comments = itemData?.description;

    setData((prev) => ({
      ...prev,
      is_active: itemData?.is_active,
      itemCode: itemData?.itemcode,
      itemName: itemData?.itemname,
      itemCtegorey: itemData?.itemcategorycd == 0 ? (itemData?.itemtype === 'SERVICE' ? '2' : '1') : `${itemData?.itemcategorycd}`,
      unite: `${itemData?.measurementcd}`,
      hsnCode: hsnCode,
      purchaseInvoice: itemData?.purchaseinvoiceflag,
      salesInvoice: itemData?.salesinvoiceflag,
      salesAccount: salesObj,
      purchaseAccount: purchaseObj,
      taxability: taxObj,
      showItem: showItemsArr,
      voucherSeries: {
        label: itemData?.serialnumber,
        value: itemData?.serialnumber,
      },
      remarks: comments,
      barcode: itemData?.barcode ?? '',
    }));
    if (setInitialState) {
      setInitialState((prev) => ({
        ...prev,
        is_active: itemData?.is_active,
        itemCode: itemData?.itemcode,
        itemName: itemData?.itemname,
        itemCtegorey: itemData?.itemcategorycd == 0 ? (itemData?.itemtype === 'SERVICE' ? '2' : '1') : `${itemData?.itemcategorycd}`,
        unite: `${itemData?.measurementcd}`,
        hsnCode: hsnCode,
        purchaseInvoice: itemData?.purchaseinvoiceflag,
        salesInvoice: itemData?.salesinvoiceflag,
        salesAccount: salesObj,
        purchaseAccount: purchaseObj,
        taxability: taxObj,
        showItem: showItemsArr,
        voucherSeries: {
          label: itemData?.serialnumber,
          value: itemData?.serialnumber,
        },
        remarks: comments,
        barcode: itemData?.barcode ?? '',
      }));
    }
    setBackdropOpen(false);
  }

  useEffect(() => {
    if (Object.keys(itemData).length > 0 && newAccID === '') {
      displayItemDetails(itemData);
    }
  }, [itemData, salesArr, purchaseArr]);
  useEffect(() => {
    if (data?.itemCtegorey == '') {
      setData((prev) => ({
        ...prev,
        itemCtegorey: Type === mainCategoryId,
      }));

      console.log('it1', mainCategoryId);
      setInitialState((prev) => ({
        ...prev,
        itemCtegorey: mainCategoryId,
      }));
    }
  }, [mainCategoryId]);
  useEffect(() => {
    setShowItems([
      {
        label: 'Purchase',
        value: 1,
      },
      {
        label: 'Sales',
        value: 2,
      },
    ]);
  }, [companyData]);
  useEffect(() => {
    listAccountMasters();
  }, [ledgerList]);
  useEffect(() => {
    if(!checkSettings){
    getGeneralSettings();
    }
  }, [Type, openSettingsModal,voucherList]);
  useEffect(() => {
    // ListUnits();
  }, [openUnitModal]);

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  function handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
      if (required && e.target.value === '') {
        e.preventDefault();
        e.stopPropagation();
        setData((prev) => ({
          ...prev,
          [name]: '',
          errorStatus: {
            ...prev.errorStatus,
            [name]: true,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: warMsg,
          },
        }));
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }

  function handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID, multiple) {
    const activeDescendantId = e.target.getAttribute('aria-activedescendant');
    const isAutocompleteOpen = document.activeElement.getAttribute('aria-expanded') === 'true';

    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
      if (multiple && e.key === 'Enter') {
        return; // Exit without moving focus to next field
      }
      
      if (required===true && (e.target.value === '' || e.target.value===undefined|| e.target.value===null) && isAutocompleteOpen && !activeDescendantId) {
        e.preventDefault();
        e.stopPropagation();
        setData((prev) => ({
          ...prev,
          [name]: '',
          errorStatus: {
            ...prev.errorStatus,
            [name]: true,
          },
          errorFields: {
            ...prev.errorFields,
            [name]: warMsg,
          },
        }));
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  function handleMultiAutoKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }
    const activeDescendantId = e.target.getAttribute('aria-activedescendant');
    const isAutocompleteOpen = document.activeElement.getAttribute('aria-expanded') === 'true';
    if (
      (e.key === 'Enter' || e.key === 'Tab') &&
      required === true &&
      !e.shiftKey &&
      data?.showItem?.length === 0 &&
      isAutocompleteOpen &&
      !activeDescendantId
    ) {
      e.preventDefault();
      e.stopPropagation();
      const element = document.getElementById(currentId);
      element?.focus();
      setData((prev) => ({
        ...prev,
        errorStatus: {
          ...prev.errorStatus,
          [name]: true,
        },
        errorFields: {
          ...prev.errorFields,
          [name]: warMsg,
        },
      }));
    } else if (e.key === 'Enter' || e.key === 'Tab') {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (!isAutocompleteOpen) {
        const element = document.getElementById(nextId);
        element?.focus();
      }
    }
  }

  return (
    <Box>
      <Grid container spacing={2}>
        {generalSettingsFlag !== -1 ? (
          <Grid item xs={12} lg={3} md={6} sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ flex: 1 }}>
              
              <Autocomplete
                openOnFocus
                fullWidth
                disableClearable
                isOptionEqualToValue={(option, value) => option.value === value?.value}
                name="itemCode"
                id="itemCode"
                options={serialNos}
                disabled={itemData?.length !== 0 || params?.view === true ? true : false}
                value={data?.itemCode}
                size="small"
                onChange={(e, newValue) => {
                  let voucherNo = '';
                  if (newValue?.value !== '') {
                    activeVouchers?.map((ele) => {
                      if (ele.serialnumber === newValue.value) {
                        voucherNo = ele.prefix + ele.nextinvoicenumber + ele.suffix;
                      }
                    });
                    setData((prev) => ({
                      ...prev,
                      voucherSeries: newValue,
                      itemCode: voucherNo,
                    }));
                  }
                }}
                onKeyDown={(e) => {
                  const warMsg = 'Item Code is required';
                  const name = 'itemCode';
                  const currentId = 'itemCode';
                  const nextId = 'itemName';
                  const prevID = '';
                  const required = true;
                  handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
                }}
                renderInput={(params) => (
                  <TextField
                    autoFocus={autoFocus}
                    error={data?.errorStatus?.voucherSeries === true ? true : false}
                    label="Item Code"
                    sx={{
                      '.MuiFormLabel-asterisk': {
                        color: 'danger.main',
                        fontSize: '16px',
                        fontWeight: 'bold',
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...params}
                  />
                )}
              />
            </Box>
            {(!checkSettings)&&(
            <Box sx={{ flex: 0.1 }}>
              <ToolTipComponent
                title="Item Settings"
                placement="top"
                tooltipContent={
                  <IconButton
                    onClick={() => {
                      if (Freeze === 1) {
                        return handleFreeze();
                      }
                      setOpenSettingsModal(true);
                    }}
                    onFocus={() => {
                      setFocusEf('settings');
                    }}
                    onBlur={() => {
                      setFocusEf('');
                    }}
                  >
                    <SettingsIcon
                      sx={{
                        color: '#808080',
                        transition: 'transform 0.3s',
                        transform: `rotate(${focusEf === 'settings' ? '75deg' : '0'})`,
                      }}
                    />
                  </IconButton>
                }
              />
            </Box>)}
          </Grid>
        ) : (
          <Grid item xs={12} lg={3} md={6} sx={{ display: 'flex', flexDirection: 'row' }}>
            <Box sx={{ flex: 2 }}>
              <TextField
                error={data?.errorStatus?.itemCode == true ? true : false}
                required={true}
                disabled={itemData?.length !== 0 || params?.view === true ? true : false}
                name="itemCode"
                id="itemCode"
                label="Item Code"
                size="small"
                type="text"
                fullWidth
                value={data?.itemCode}
                onChange={(e) => {
                  const { name, value } = e.target;
                     const { valid, message } = CheckVoucherValid(value,'Item Code');
                  if (value == '') {
                    setData((prev) => ({
                      ...prev,
                      itemCode: value,
                      errorStatus: {
                        ...prev.errorStatus,
                        itemCode: true,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        itemCode: 'Item Code is required',
                      },
                    }));
                  }else if(!valid){
                      setData((prev) => ({
                      ...prev,
                      itemCode: value,
                      errorStatus: {
                        ...prev.errorStatus,
                        itemCode: true,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        itemCode: message,
                      },
                    }));
                  } else {
                    setData((prev) => ({
                      ...prev,
                      itemCode: value,
                      errorStatus: {
                        ...prev.errorStatus,
                        itemCode: false,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        itemCode: '',
                      },
                    }));
                  }
                }}
                onKeyDown={(e) => {
                  const warMsg = 'Item Code is required';
                  const name = 'itemCode';
                  const currentId = 'itemCode';
                  const nextId = 'itemName';
                  const prevID = '';
                  const required = true;

                  handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
                }}
                sx={{
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{ inputProps: { maxLength: 16 } }}
              />

              <Typography
                sx={{
                  marginTop: '2px',
                  marginLeft: '10px',
                  marginBottom: '5px',
                  fontSize: '11px',
                  color: 'danger.main',
                }}
              >
                {data?.errorFields.itemCode}
              </Typography>
            </Box>
               {(!checkSettings) &&(
            <Box sx={{ flex: 0.1 }}>
              <ToolTipComponent
                title="Item Settings"
                placement="top"
                tooltipContent={
                  <IconButton
                    onClick={() => {
                      if (Freeze === 1) {
                        return handleFreeze();
                      }
                      setOpenSettingsModal(true);
                    }}
                  >
                    <SettingsIcon sx={{ color: '#808080' }} />
                  </IconButton>
                }
              />
            </Box>)}
          </Grid>
        )}
        <Grid item xs={12} lg={3} md={6}>
          <TextField
            autoFocus={autoFocus}
            error={data?.errorStatus?.itemName === true ? true : false}
            name="itemName"
            id="itemName"
            label="Item Name"
            size="small"
            type="text"
            fullWidth
            required={true}
            disabled={params?.view === true ? true : false}
            value={data?.itemName}
           onChange={(e) => {
  const value = e.target.value;

 const allowedPattern = /^.*$/;

  if (value === '') {
    setData((prev) => ({
      ...prev,
      itemName: value.trimStart(),
      errorStatus: {
        ...prev.errorStatus,
        itemName: true,
      },
      errorFields: {
        ...prev.errorFields,
        itemName: 'Item Name is required',
      },
    }));
  } else if (value.length >= 100) {
    setData((prev) => ({
      ...prev,
      itemName: value,
      errorStatus: {
        ...prev.errorStatus,
        itemName: true,
      },
      errorFields: {
        ...prev.errorFields,
        itemName: 'Item Name must be less than 100 characters',
      },
    }));
  } else {
    if (!allowedPattern.test(value)) {
      setData((prev) => ({
        ...prev,
        itemName: value.trimStart(),
        errorStatus: {
          ...prev.errorStatus,
          itemName: true,
        },
        errorFields: {
          ...prev.errorFields,
          itemName: 'Invalid Item Name',
        },
      }));
    } else {
      const trimmedValue = value.trimStart();


      const capitalizedValue = trimmedValue
        .split(/\s+/) 
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      setData((prev) => ({
        ...prev,
        itemName: capitalizedValue,
        errorStatus: {
          ...prev.errorStatus,
          itemName: false,
        },
        errorFields: {
          ...prev.errorFields,
          itemName: '',
        },
      }));
    }
  }
}}

            onKeyDown={(e) => {
              const warMsg = 'Item Name is required';
              const name = 'itemName';
              const currentId = 'itemName';
              const nextId = 'treeDrp';
              const prevID = 'itemCode';
              const required = true;

              handleTextKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
            }}
            sx={{
              '.MuiFormLabel-asterisk': {
                color: 'danger.main',
                fontSize: '16px',
                fontWeight: 'bold',
              },
            }}
          />
          <Typography
            sx={{
              marginTop: '2px',
              marginLeft: '10px',
              marginBottom: '5px',
              fontSize: '11px',
              color: 'danger.main',
            }}
          >
            {data?.errorFields?.itemName}
          </Typography>
        </Grid>
        <Grid item xs={12} lg={3} md={6}>
          <TextField
            name="barcode"
            id="barcode"
            label="Barcode"
            InputLabelProps={{ shrink: true }}
            size="small"
            type="text"
            fullWidth
            disabled={data?.itemName === '' || params?.view === true}
            value={data?.barcode ?? ''}
            inputProps={{ maxLength: 50 }}
            onChange={(e) => {
              setData((prev) => ({ ...prev, barcode: e.target.value }));
            }}
          />
        </Grid>
        <Grid item xs={12} lg={3} md={6}>
          <Box
            id={'category'}
            sx={{
              display: 'flex',
              width: '100%',
              pointerEvents: data?.itemName === '' ? 'none' : '',
            }}
          >
            <TreeDropdown
              setMainCategoryId={setMainCategoryId}
              parentDetails={categoryId}
              MainParent={Type}
              setState={setData}
              setInitialState={setInitialState}
              onChange={categoryChange}
              disabled={params?.view === true || data?.itemName === '' ? true : false}
              label="Category"
            />
          </Box>
        </Grid>
        <Grid item xs={12} lg={3} md={6} className={window.innerWidth > 1530 ? 'ToRightDrp' : ''}>
          <Autocomplete
            disablePortal={true}
            disabled={data?.itemName === '' || params?.view === true ? true : false}
            id="unit"
            name="unit"
            size="small"
            openOnFocus
            autoFocus
            options={[...unitsArrayList, 'Configure / Add Units']}
            getOptionLabel={(option) => option.option}
            ListboxProps={{
              style: { paddingTop: 0, paddingBottom: 0 }, // Ensure top padding is removed
            }}
            renderOption={(props, option) => (
              <>
                {option === 'Configure / Add Units' ? (
                  <MenuItem
                    value={'addUnits'}
                    onClick={(e) => {
                      e.stopPropagation();
                      setUnitModal(true);
                    }}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'sticky',
                      bottom: '0px',
                      color: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : '',
                      backgroundColor: grey[50],
                      '&:hover': {
                        backgroundColor: grey[200],
                      },
                    }}
                  >
                    <Settings fontSize="small" sx={{ marginRight: '5px' }} />
                    <ListItemText primary={'Add Units'} />
                  </MenuItem>
                ) : (
                  <li {...props} key={option.value} value={option.value}>
                    {/* <ListItemText primary={option.option} /> */}
                    {option.option}
                  </li>
                )}
              </>
            )}
            value={unitsArrayList.find((unit) => unit.value === data?.unite) || null}
            onChange={(event, newValue) => {
              if (!newValue || newValue?.value !== 'addUnits') {
                setData((prev) => ({
                  ...prev,
                  unite: newValue ? newValue.value : '',
                  errorStatus: {
                    ...prev.errorStatus,
                    unite: Type === 'GOODS' ? !newValue : prev.errorStatus.unite,
                  },
                  errorFields: {
                    ...prev.errorFields,
                    unite: Type === 'GOODS' ? (!newValue ? 'Unit is required' : '') : prev.errorFields.unite,
                  },
                }));
              }
            }}
            onKeyDown={(e) => {
              const warMsg = 'Unit is required';
              const name = 'unite';
              const currentId = 'unit';
              const nextId = companyType === 1 ? 'showItem' : 'hsnCode';
              const prevID = 'treeDrp';
              const required = 
              // Type === 'SERVICE' ? false :
               true;
              handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
            }}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => (
              <TextField
                error={data?.errorStatus?.unite === true ? true : false}
                {...params}
                label="Unit of Measurement"
                required={
                  // Type === 'SERVICE' ? false : 
                  true}
                variant="outlined"
                id="unite"
                name="unite"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                }}
              />
            )}
          />
          <Typography
            sx={{
              marginTop: '2px',
              marginLeft: '10px',
              marginBottom: '0px',
              fontSize: '11px',
              color: 'danger.main',
            }}
          >
            {data?.errorFields?.unite}
          </Typography>
        </Grid>

        {companyData?.relatedcompanydetailsnew?.[0].registrationtype !== 1 && (
          <Grid item xs={12} lg={3} md={6}>
            <Autocomplete
              id="hsnCode"
              name="hsnCode"
              disableClearable
              disablePortal={true}
              placeholder="HSN Code"
              disabled={data?.itemName === '' || params?.view === true ? true : false}
              sx={{ width: '100%' }}
              getOptionDisabled={(option) => option === (Type === 'GOODS' ? 'Add HSN Code' : 'Add SAC Code')}
              options={Type === 'GOODS' ? ['Add HSN Code', ...filterHSN] : ['Add SAC Code', ...filterHSN]}
              isOptionEqualToValue={(option, value) => option?.value == value?.value}
              openOnFocus
              value={data?.hsnCode}
              onChange={(e, newValue) => {
                if (newValue?.value ==="" && companyType===2) {
                  setData((prev) => ({
                    ...prev,
                    hsnCode: newValue,
                    errorStatus: {
                      ...prev.errorStatus,
                      hsnCode: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      hsnCode: Type === 'GOODS' ? 'HSN Code is required' : 'SAC Code is required',
                    },
                  }));
                } else {
                  setData((prev) => ({
                    ...prev,
                    hsnCode: newValue,
                    errorStatus: {
                      ...prev.errorStatus,
                      hsnCode: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      hsnCode: '',
                    },
                  }));
                }
              }}
              onInputChange={(e, newValue) => {
                setRow(0);
                if (newValue) {
                  searchHSNDetails(newValue, 0, 20);
                } else {
                  searchHSNDetails('', 0, 20);
                }
              }}
              ListboxProps={HSNListboxProps}
              onKeyDown={(e) => {
                const warMsg =Type === 'GOODS' ? 'HSN Code is required' : 'SAC Code is required';
                const name = 'hsnCode';
                const currentId = 'hsnCode';
                const nextId =(e.target.value || companyType===3)? 'showItem':"hsnCode";
                const prevID = 'unit';
                const required = companyType === 2 ? true : false;
                handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
              }}
              size="small"
              renderInput={(params) => (
                <TextField
                  error={data?.errorStatus?.hsnCode === true ? true : false}
                  placeholder="Search"
                  required={companyType===2?true:false}
                  sx={{
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '16px',
                      fontWeight: 'bold',
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...params}
                  label={Type === 'GOODS' ? 'HSN Code' : 'SAC Code'}
                />
              )}
              renderOption={(props, option) => (
                <>
                  {option === (Type === 'GOODS' ? 'Add HSN Code' : 'Add SAC Code') ? (
                    <MenuItem
                      value={'addHsn'}
                      onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        setOpenHsnModal(true);
                        setHSNParamsID('');
                      }}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        position: 'sticky',
                        top: '-8px',
                        mt: '-8px',
                        backgroundColor: grey[50],
                        '&:hover': {
                          backgroundColor: grey[200],
                        },
                      }}
                    >
                      <AddBox
                        fontSize="small"
                        sx={{
                          marginRight: '5px',
                          color: 'primary.main',
                        }}
                      />
                      <ListItemText sx={{ color: 'primary.main' }} primary={Type === 'GOODS' ? 'Add HSN Code' : 'Add SAC Code'} />
                    </MenuItem>
                  ) : (
                    <li {...props}>{option.label}</li>
                    
                  )}
                </>
              )}
            />

            <Typography
              sx={{
                marginTop: '2px',
                marginLeft: '10px',
                marginBottom: '0px',
                fontSize: '11px',
                color: 'danger.main',
              }}
            >
              {data?.errorFields?.hsnCode}
            </Typography>
          </Grid>
        )}

        <Grid item xs={12} lg={3} md={6}>
          <Autocomplete
            size="small"
            multiple
            openOnFocus
            autoFocus
            disableClearable
            options={showItems}
            name="showItem"
            id="showItem"
            fullWidth
            getOptionLabel={(option) => option?.label}
            disableCloseOnSelect
            disabled={
              data?.itemName === '' || params?.view === true
                ? //  && (!page && page !== "Purchase" )
                  true
                : false
            }
            value={data?.showItem}
            onChange={(e, newValue) => {
              let puchaseFlag = 0;
              let salesFlag = 0;

              let uniqueValues = newValue?.filter(
                (item, index, self) => index === self.findIndex((t) => t.value === item.value && t.label === item.label)
              );
              if (
                newValue.length === 0
                // data.purchaseInvoice === 0 ||
                // data.salesInvoice === 0
              ) {
                setPurchasePriceRows([newPurchaseObj]);
                setSellingPriceRows([newSalesObj]);
                setSalesValid(true);
                setPurchaseValid(true);
              }
              if (uniqueValues.length == 0) {
                setData((prev) => ({
                  ...prev,
                  showItem: newValue,
                  purchaseInvoice: 0,
                  salesInvoice: 0,
                  purchaseAccount: puchaseFlag === 1 ? { label: 'Purchase A/c', value: 13 } : { label: '', value: '' },
                  salesAccount: salesFlag === 1 ? { label: 'Sales A/c', value: 17 } : { label: '', value: '' },
                  errorStatus: {
                    ...prev.errorStatus,
                    showItem: true,
                  },
                  errorFields: {
                    ...prev.errorFields,
                    showItem: 'Please select the Item in Purchase or Sales Invoice',
                  },
                }));
              } else {
                if (checked === true) {
                  // uniqueValues.map((ele) => {
                  //   if (ele.value === 1) {
                  //     puchaseFlag = 1;
                  //   }
                  //   if (ele.value === 2) {
                  //     salesFlag = 1;
                  //   }
                  // });
                  puchaseFlag = uniqueValues.some((ele) => ele.value === 1) ? 1 : 0;
                  salesFlag = uniqueValues.some((ele) => ele.value === 2) ? 1 : 0;
                  if (puchaseFlag === 0) {
                    setPurchasePriceRows([newPurchaseObj]);

                    setPurchaseValid(true);
                  }
                  if (salesFlag === 0) {
                    setSellingPriceRows([newSalesObj]);
                    setSalesValid(true);
                  }
                  if (salesFlag === 1 && Object.keys(itemData).length > 0) {
                    if (updatedSalesPrice.length > 0) {
                      setSellingPriceRows(updatedSalesPrice);
                    }
                  }
                  if (puchaseFlag === 1 && Object.keys(itemData).length > 0) {
                    if (updatedPurchasePrice.length > 0) {
                      setPurchasePriceRows(updatedPurchasePrice);
                    }
                  }

                  setData((prev) => ({
                    ...prev,
                    showItem: uniqueValues,
                    purchaseInvoice: puchaseFlag,
                    salesInvoice: salesFlag,
                    purchaseAccount: puchaseFlag === 1 ? { label: 'Purchase A/c', value: 13 } : { label: '', value: '' },
                    salesAccount: salesFlag === 1 ? { label: 'Sales A/c', value: 17 } : { label: '', value: '' },
                    errorStatus: {
                      ...prev.errorStatus,
                      showItem: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      showItem: '',
                    },
                  }));
                }
              }
            }}
            onKeyDown={(e) => {
              const warMsg = 'Please select the Item in Purchase or Sales Invoice';
              const name = 'showItem';
              const currentId = 'showItem';
              const nextId = 'purchaseAccount';
              const prevID = companyType === 1 ? 'unit' : 'hsnCode';
              const required = true;

              handleMultiAutoKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
            }}
            renderInput={(paramses) => (
              <TextField
                error={data?.errorStatus?.showItem === true}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                {...paramses}
                variant="outlined"
                required={true}
                label="Show Item In Invoice"
                sx={{
                  '.MuiFormLabel-root': {
                    // color: params?.view ? "rgba(85, 82, 82, 0.38)" : "inherit", // Change color when disabled
                    color: theme?.palette?.TmId.id.toString().includes('9')
                      ? data?.itemName
                        ? 'white'
                        : 'rgba(255, 252, 252, 0.38)'
                      : data?.itemName
                      ? 'black'
                      : 'rgba(85, 82, 82, 0.38)',
                  },
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                  '.MuiOutlinedInput-root': {
                    height: '35px',
                  },
                }}
              />
            )}
            renderOption={(props, option, { selected }) => (
              <li {...props} key={option.value} value={option.value} style={{}}>
                {
                  <>
                    <Checkbox
                      value={option.value}
                      sx={{
                        fontSize: '16px',
                        paddingTop: '0px',
                        paddingBottom: '0px',
                      }}
                      onChange={(e) => {
                        const isChecked = e.target.checked;

                        setData((prev) => {
                          let updatedShowItem;

                          if (isChecked) {
                            // Checkbox is checked, add the item to data.showItem if it doesn't exist
                            if (!prev.showItem?.find((item) => item.value === option.value)) {
                              updatedShowItem = [...(prev.showItem || []), { label: 'Purchase', value: option.value }];
                            } else {
                              updatedShowItem = prev.showItem;
                            }
                          } else {
                            // Checkbox is unchecked, remove the item from data.showItem if it exists
                            updatedShowItem = prev.showItem?.filter((item) => item.value !== option.value);
                          }

                          return {
                            ...prev,
                            showItem: updatedShowItem,
                          };
                        });
                      }}
                      color="primary"
                      checked={data?.showItem?.find((item) => item.value === option.value) !== undefined}
                    />
                  </>
                }
                {option.label}
              </li>
            )}
          />

          <Typography
            sx={{
              marginTop: '2px',
              marginLeft: '10px',
              marginBottom: '0px',
              fontSize: '11px',
              color: 'danger.main',
            }}
          >
            {data?.errorFields?.showItem}
          </Typography>
        </Grid>
        <Grid item xs={12} lg={3} md={6}>
          <Autocomplete
            openOnFocus
            autoFocus
            fullWidth
            disableClearable
            id="purchaseAccount"
            name="purchaseAccount"
            disabled={data?.purchaseInvoice === 0 || params?.view === true ? true : false}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            value={data?.purchaseAccount}
            ListboxProps={{
              style: { paddingTop: 0 }, // Ensure top padding is removed
            }}
            options={
              displayAllAccounts.purchase
                ? [
                    'Add Purchase A/C',
                    ...allAccountArr.sort((a, b) => {
                      if (a.label.toUpperCase() < b.label.toUpperCase()) return -1;
                      if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
                      return 0;
                    }),
                    'Show All Accounts',
                  ]
                : [
                    'Add Purchase A/C',
                    ...purchaseArr.sort((a, b) => {
                      if (a.label.toUpperCase() < b.label.toUpperCase()) return -1;
                      if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
                      return 0;
                    }),
                    'Show All Accounts',
                  ]
            }
            size="small"
            onChange={(e, newValue) => {
              if (newValue?.value !== 'Add Purchase A/C') {
                if (newValue === '') {
                  setData((prev) => ({
                    ...prev,
                    errorStatus: {
                      ...prev.errorStatus,
                      purchaseAccount: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      purchaseAccount: ' Purchase Account  is required',
                    },
                  }));
                } else {
                  setData((prev) => ({
                    ...prev,
                    purchaseAccount: newValue,
                    errorStatus: {
                      ...prev.errorStatus,
                      purchaseAccount: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      purchaseAccount: '',
                    },
                  }));
                }
              }
            }}
            onKeyDown={(e) => {
              let puchaseFlag = data.showItem.some((ele) => ele.value === 1) ? 1 : 0;
              let salesFlag = data.showItem.some((ele) => ele.value === 2) ? 1 : 0;
              const salesRows = [...sellingPriceRows];
              const purchaseRows = [...purchasePriceRows];
              const zeroSalesIndex = salesRows.findIndex((row) => row.amount === 0);
              const zeroPurchaseIndex = purchaseRows.findIndex((row) => row.amount === 0);
              const warMsg = ' Purchase Account  is required';
              const name = 'purchaseAccount';
              const currentId = 'purchaseAccount';
              const nextId =
                salesFlag === 0
                  ? registrationType !== 1
                    ? 'taxability'
                    : purchasePriceObj.isActive + `${zeroPurchaseIndex}`
                  : 'salesAccount';
              const prevID = 'showItem';
              const required = true;

              handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
            }}
            renderInput={(params) => (
              <TextField
                required={data?.purchaseInvoice === 1 ? true : false}
                label="Under Purchase A/c"
                sx={{
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                {...params}
              />
            )}
            renderOption={(props, option) => (
              <>
                {option === 'Add Purchase A/C' ? (
                  <MenuItem
                    value={'addAccount'}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      setOpenModalFlag(true);
                      setOpenPurchaseAccountModal(true);
                      setOpenSalesAccountModal(false);
                      setAccountType('Purchase');
                    }}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'sticky',
                      top: '0px',
                      backgroundColor: grey[50],
                      '&:hover': {
                        backgroundColor: grey[200],
                      },
                    }}
                  >
                    <AddBox
                      fontSize="small"
                      sx={{
                        marginRight: '5px',
                        color: 'primary.main',
                      }}
                    />
                    <ListItemText sx={{ color: 'primary.main' }} primary={'Add Purchase A/C'} />
                  </MenuItem>
                ) : option === 'Show All Accounts' ? (
                  <MenuItem
                    value={'showAllAccounts'}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'sticky',
                      bottom: '-7.5px',
                      bottom: '-8px',
                      mb: '-8px',
                      zIndex: 1,
                      ml: '-10px',
                      backgroundColor: grey[50],
                      '&:hover': {
                        backgroundColor: grey[200],
                      },
                    }}
                    onClick={(e) => {
                      setDisplayAllAccounts((prev) => ({
                        ...prev,
                        purchase: !displayAllAccounts.purchase,
                      }));
                    }}
                  >
                    <Checkbox
                      checked={displayAllAccounts.purchase}
                      fontSize="small"
                      sx={{
                        marginLeft: '10px', // Align horizontally with AddBox
                        marginRight: '5px', // Spacing similar to AddBox
                        width: '20px', // Same size as AddBox
                        height: '20px', // Same size as AddBox
                        color: 'primary.main',
                        verticalAlign: 'middle', // Align vertically with AddBox
                      }}
                      onChange={(e) => {
                        e.stopPropagation();
                        if (e.target.checked == true) {
                          setDisplayAllAccounts((prev) => ({
                            ...prev,
                            purchase: true,
                          }));
                        } else {
                          setDisplayAllAccounts((prev) => ({
                            ...prev,
                            purchase: false,
                          }));
                        }
                      }}
                    />
                    <ListItemText sx={{ color: 'primary.main' }} primary={'Show All Accounts'} />
                  </MenuItem>
                ) : (
                  <li {...props}>
                    <span>
                      <b>{option.label}</b> {option?.groupName?.length ? <i>({option?.groupName?.trim()})</i> : ''}
                    </span>
                  </li>
                )}
              </>
            )}
          />
          <Typography
            sx={{
              marginTop: '2px',
              marginLeft: '10px',
              marginBottom: '0px',
              fontSize: '11px',
              color: 'danger.main',
            }}
          >
            {data?.errorFields?.purchaseInvoice}
          </Typography>
        </Grid>
        <Grid item xs={12} lg={3} md={6} className={window.innerWidth > 1530 ? 'ToRightDrp' : ''}>
          <Autocomplete
            openOnFocus
            autoFocus
            disablePortal={true}
            disableClearable
            fullWidth
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            id="salesAccount"
            name="salesAccount"
            disabled={data?.salesInvoice === 0 || params?.view === true ? true : false}
            value={data?.salesAccount}
            options={
              displayAllAccounts.sales
                ? [
                    'Add Sales A/C',
                    ...allAccountArr.sort((a, b) => {
                      if (a.label.toUpperCase() < b.label.toUpperCase()) return -1;
                      if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
                      return 0;
                    }),
                    'Show All Accounts',
                  ]
                : [
                    'Add Sales A/C',
                    ...salesArr.sort((a, b) => {
                      if (a.label.toUpperCase() < b.label.toUpperCase()) return -1;
                      if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
                      return 0;
                    }),
                    'Show All Accounts',
                  ]
            }
            size="small"
            onChange={(e, newValue) => {
              if (newValue?.value !== 'Add Sales A/C') {
                if (newValue === '') {
                  setData((prev) => ({
                    ...prev,
                    errorStatus: {
                      ...prev.errorStatus,
                      salesAccount: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      salesAccount: ' Sales Account  is required',
                    },
                  }));
                } else {
                  setData((prev) => ({
                    ...prev,
                    salesAccount: newValue,
                    errorStatus: {
                      ...prev.errorStatus,
                      salesAccount: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      salesAccount: '',
                    },
                  }));
                }
              }
            }}
            ListboxProps={{
              style: { paddingTop: 0 }, // Ensure top padding is removed
            }}
            onKeyDown={(e) => {
              let puchaseFlag = data.showItem.some((ele) => ele.value === 1) ? 1 : 0;
              let salesFlag = data.showItem.some((ele) => ele.value === 2) ? 1 : 0;
              const salesRows = [...sellingPriceRows];
              const purchaseRows = [...purchasePriceRows];
              const zeroSalesIndex = salesRows.findIndex((row) => row.amount === 0);
              const zeroPurchaseIndex = purchaseRows.findIndex((row) => row.amount === 0);
              const warMsg = ' Sales Account  is required';
              const name = 'salesAccount';
              const currentId = 'salesAccount';
              const nextId = registrationType !== 1 ? 'taxability' : sellingPriceObj.isActive + `${zeroSalesIndex}`;
              const prevID = puchaseFlag === 0 ? 'showItem' : 'purchaseAccount';
              const required = true;

              handleAutoCompleteKeyDown(e, setData, name, currentId, nextId, required, warMsg, prevID);
            }}
            renderInput={(params) => (
              <TextField
                className={window.innerWidth > 1530 ? 'ToRightDrp' : ''}
                required={data?.salesInvoice === 1 ? true : false}
                label="Under Sales A/c"
                sx={{
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                {...params}
              />
            )}
            renderOption={(props, option) => (
              <>
                {option === 'Add Sales A/C' ? (
                  <MenuItem
                    value={'addAccount'}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      setOpenModalFlag(true);
                      setOpenSalesAccountModal(true);
                      setOpenPurchaseAccountModal(false);
                      setAccountType('Sales');
                    }}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'sticky',
                      mt: 0,
                      pt: 0,
                      top: '0px',
                      backgroundColor: grey[50],
                      '&:hover': {
                        backgroundColor: grey[200],
                      },
                    }}
                  >
                    <AddBox
                      fontSize="small"
                      sx={{
                        marginRight: '5px',
                        color: 'primary.main',
                      }}
                    />
                    <ListItemText sx={{ color: 'primary.main' }} primary={'Add Sales A/C'} />
                  </MenuItem>
                ) : option === 'Show All Accounts' ? (
                  <MenuItem
                    value={'showAllAccounts'}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'sticky',
                      bottom: '-7.5px',
                      bottom: '-8px',
                      mb: '-8px',
                      zIndex: 1,
                      ml: '-10px',
                      backgroundColor: grey[50],
                      '&:hover': {
                        backgroundColor: grey[200],
                      },
                    }}
                    onClick={(e) => {
                      setDisplayAllAccounts((prev) => ({
                        ...prev,
                        sales: !displayAllAccounts.sales,
                      }));
                    }}
                  >
                    <Checkbox
                      checked={displayAllAccounts.sales}
                      fontSize="small"
                      sx={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '20px',
                        height: '20px',
                        color: 'primary.main',
                        verticalAlign: 'middle',
                      }}
                      onChange={(e) => {
                        e.stopPropagation();
                        if (e.target.checked == true) {
                          setDisplayAllAccounts((prev) => ({
                            ...prev,
                            sales: true,
                          }));
                        } else {
                          setDisplayAllAccounts((prev) => ({
                            ...prev,
                            sales: false,
                          }));
                        }
                      }}
                    />
                    <ListItemText sx={{ color: 'primary.main' }} primary={'Show All Accounts'} />
                  </MenuItem>
                ) : (
                  <li {...props}>
                    <span>
                      <b>{option.label}</b> {option?.groupName?.length ? <i>({option?.groupName?.trim()})</i> : ''}
                    </span>
                  </li>
                )}
              </>
            )}
          />
          <Typography
            sx={{
              marginTop: '2px',
              marginLeft: '10px',
              marginBottom: '0px',
              fontSize: '11px',
              color: 'danger.main',
            }}
          >
            {data?.errorFields?.salesAccount}
          </Typography>
        </Grid>
        {companyData?.relatedcompanydetailsnew?.[0].registrationtype !== 1 && (
          <Grid item xs={12} lg={3} md={6}>
            <Autocomplete
              openOnFocus
              fullWidth
              autoFocus
              disableClearable
              isOptionEqualToValue={(option, value) => option.value === value?.value}
              id="taxability"
              name="taxability"
              value={data?.taxability}
              disabled={data?.itemName === '' || params?.view === true ? true : false}
              options={Taxability}
              size="small"
              onChange={(e, newValue) => {
                if (newValue === '') {
                  setData((prev) => ({
                    ...prev,
                    errorStatus: {
                      ...prev.errorStatus,
                      taxability: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      taxability: 'Taxability  is required',
                    },
                  }));
                } else {
                  setTaxableValue(newValue.value);
                  if (newValue.value !== 1 && newValue.value !== 4) {
                    setRegistrationType(1);
                  } else {
                    setRegistrationType('');
                  }
                  setData((prev) => ({
                    ...prev,
                    taxability: newValue,
                    errorStatus: {
                      ...prev.errorStatus,
                      taxability: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      taxability: '',
                    },
                  }));
                }
              }}
              onKeyDown={(e) => {
                const activeDescendantId = e.target.getAttribute('aria-activedescendant');
                const isAutocompleteOpen = document.activeElement.getAttribute('aria-expanded') === 'true';

                let salesFlag = data.showItem.some((ele) => ele.value === 2) ? 1 : 0;
                let prevID = salesFlag === 1 ? 'salesAccount' : 'purchaseAccount';

                if (e.key === 'Tab' && e.shiftKey) {
                  e.preventDefault();
                  e.stopPropagation();
                  const prevElement = document.getElementById(prevID);
                  prevElement?.focus();
                  return;
                }

                if ((e.key === 'Enter' || e.key === 'Tab') && e.target.value === '' && !activeDescendantId && isAutocompleteOpen) {
                  const element = document.getElementById('taxability');
                  element?.focus();
                  setData((prev) => ({
                    ...prev,
                    taxability: '',
                    errorStatus: {
                      ...prev.errorStatus,
                      taxability: true,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      taxability: ' Taxability Account  is required',
                    },
                  }));
                } else if (e.key === 'Enter' || e.key === 'Tab') {
                  e.preventDefault();
                  e.stopPropagation();
                  const salesRows = [...sellingPriceRows];
                  const purchaseRows = [...purchasePriceRows];
                  const zeroSalesIndex = salesRows.findIndex((row) => row.amount === 0);
                  const zeroPurchaseIndex = purchaseRows.findIndex((row) => row.amount === 0);
                  const puchaseFlag = data.showItem.some((ele) => ele.value === 1) ? 1 : 0;
                  const salesFlag = data.showItem.some((ele) => ele.value === 2) ? 1 : 0;

                  // if (!isAutocompleteOpen) {
                  if (salesFlag === 0) {
                    const element = document.getElementById(purchasePriceObj.isActive + `${zeroPurchaseIndex}`);
                    element?.focus();
                  } else {
                    const element = document.getElementById(sellingPriceObj.isActive + `${zeroSalesIndex}`);

                    element?.focus();
                  }
                  // }
                }
              }}
              renderInput={(params) => (
                <TextField
                  error={data?.errorStatus?.taxability === true ? true : false}
                  required={true}
                  label="Taxability"
                  sx={{
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '16px',
                      fontWeight: 'bold',
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...params}
                />
              )}
            />
            <Typography
              sx={{
                marginTop: '2px',
                marginLeft: '10px',
                marginBottom: '0px',
                fontSize: '11px',
                color: 'danger.main',
              }}
            >
              {data?.errorFields?.taxability}
            </Typography>
          </Grid>
        )}
      </Grid>

      {/* //\\ <VoucherSettingsModal
        //   open={openSettingsModal}
        //   setGeneralSettingsFlag={setGeneralSettingsFlag}
        //   setOpen={setOpenSettingsModal}
        //   showWarningSnackbar={showWarningSnackbar}
        //   showSuccessSnackbar={showSuccessSnackbar}
        //   invoiceLabels={{
        //     voucherModalName: "Item Code Settings",
        //     voucherType: Type === "GOODS" ? "Item" : "Service",
        //     voucherName: Type === "GOODS" ? "Item Code" : "Service Code",
        //   }}
        //   setState={setData}
        //   voucherNos={[]}
        //   companyData={companyData}
        //   Passfn={getGeneralSettings}
        // /> */}
      {/* {openSettingsModal === true && ( */}
      <NewVoucherSettingsModal
        open={openSettingsModal}
        label="Item Code"
        type={Type === 'GOODS' ? 'Item' : 'Service'}
        setOpen={setOpenSettingsModal}
      />
      {/* )} */}
      {openUnitModal === true && (
        <AddUnitsModal
          open={openUnitModal}
          setOpen={setUnitModal}
          setNewUnit={setNewUnit}
          uqcArray={uqcArrayList}
          currentUnit={data?.unite}
          setData={setData}
          listData={() => getUnit('UNITS')}
        />
      )}
      {openHsnModal === true && (
        <AddHSNModal
          open={openHsnModal}
          setOpen={setOpenHsnModal}
          setData={setData}
          data={data}
          setFilterHSN={setFilterHSN}
          filteredHSN={filterHSN}
          searchHSNSAC={() => searchHSNDetails('', 0, 20)}
          hsnParamsID={hsnParamsID}
          page={Type}
          itemType={Type}
        />
      )}
      {openMpdalFlag === true && (
        <AddItemsAccountModal
          open={accountType === 'Sales' ? openSalesAccountModal : openPurchaseAccountModal}
          setOpen={accountType === 'Sales' ? setOpenSalesAccountModal : setOpenPurchaseAccountModal}
          setData={setData}
          setAllAccount={accountType === 'Sales' ? setSalesArr : setPurchaseArr}
          accountType={accountType}
          setAccNames={setAccNames}
          setNewAccID={setNewAccID}
        />
      )}
    </Box>
  );
}

export default ItemBasicDetails;
